import { Component, Input, Output, EventEmitter, AfterViewInit, OnDestroy, OnChanges, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import * as AOS from 'aos';
import { SubscriptionService } from 'src/app/services/subscription.service';

@Component({
  selector: 'app-crm-price',
  templateUrl: './crm-price.component.html',
  styleUrls: ['./crm-price.component.scss']
})
export class CrmPriceComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Input() email?: string;
  @Input() telephone?: string;
  @Input() address?: string;
  @Output() getStarted = new EventEmitter<void>();


  @Input() country: string;

  countryCode: any = 'IN';
  detectedCountry: any = 'IN'; // Default to India for development/testing
  detectedCountryName: string = '';
  @Input() currency: string = '';
  currencySymbol = '₹';
  billingCycle: "month" | "year" = "month";
  countryName: string = "default";

  private billingToggle?: HTMLElement | null;
  private monthlyLabel?: Element | null;
  private annualLabel?: Element | null;
  private collapsibleRows?: NodeListOf<Element>;
  private boundToggleFns: Array<() => void> = [];
  private boundKeyHandlers: Array<(e: Event) => void> = [];

  private countryToCurrencySymbol: { [countryCode: string]: string } = {
    IN: '₹', // India
    US: '$', // United States
    CA: '$', // Canada (same symbol as US)
    GB: '£', // United Kingdom
    AU: '$', // Australia
    EU: '€', // Europe (we detect country codes below — map common ones individually if preferred)
    DE: '€',
    FR: '€',
    NL: '€',
    ES: '€',
    IT: '€',
    JP: '¥', // Japan
    CN: '¥', // China (CNY uses ¥ symbol too)
    SG: '$', // Singapore
    AE: 'د.إ', // UAE dirham example
    INE: '₹'
    // add more as needed
  };

  pricing = {
    india: {
      lite: {month: 1653, year: 16530},
      standard: {month: 2523, year: 25230},
      plus: {month: 4263, year: 42630},
      omni: {month: 5133, year: 5130},
      currency: '₹' 
    },
    canada: {
      lite: {month: 99, year: 999},
      standard: {month: 199, year: 1999},
      plus: {month: 299, year: 2999},
      omni: {month: 499, year: 4999},
      currency: '$'
    },
    default: {
      lite: {month: 99, year: 999},
      standard: {month: 199, year: 1999},
      plus: {month: 299, year: 2999},
      omni: {month: 499, year: 4999},
      currency: '$'
    },
  }

  constructor(
    private router: Router,
    private subscriptionService: SubscriptionService
  ) {
  }

// ngOnInit() {
//   // Default fallback values
//   if (!this.email) this.email = "hello@scanfluence.com";
//   if (!this.telephone) this.telephone = "+1 (437) 826 SCAN";
//   if (!this.address) this.address = "3600 Steeles Avenue East, Markham, ON, L3R 9Z7";
// }
  async ngOnInit() {
    const countryInfo = await this.detectCountryInfo();
    this.detectedCountry = countryInfo.code;
    this.detectedCountryName = countryInfo.name;
    this.isLoadingPlans = true;
    try {
      await this.getSubscriptionPlans();
    } finally {
      this.isLoadingPlans = false;
    }
    this.checkForTeam();
  }
ngOnChanges() {
  if (this.email == null) {
    this.email = "hello@scanfluence.com";
  }

  if (this.telephone == null) {
    this.telephone = "+1 (437) 826 SCAN";
  }

  if (this.address == null) {
    this.address = "3600 Steeles Avenue East, Markham, ON, L3R 9Z7";
  }
}


  ngAfterViewInit(): void {
    //console.log('init crm price, input currency', this.currency);
    //console.log('countryyyy', this.country);
    if (this.country && ['india', 'canada'].includes(this.country.toLowerCase())) {
      this.countryName = this.country.toLowerCase();
    } else this.countryName = 'default';
    AOS.init();

    // this.detectAndApplyCurrencySymbol();

    this.setupBillingToggle();
    this.setupCollapsibleRows();
  }

  ngOnDestroy(): void {
    if (this.billingToggle && this.boundToggleFns.length) {
      this.boundToggleFns.forEach(fn => this.billingToggle!.removeEventListener('click', fn));
    }

    if (this.collapsibleRows && this.boundToggleFns.length) {
      let i = 0;
      this.collapsibleRows.forEach((row) => {
        const clickFn = this.boundToggleFns[i++];
        if (clickFn) row.removeEventListener('click', clickFn);
      });
    }

    if (this.collapsibleRows && this.boundKeyHandlers.length) {
      let j = 0;
      this.collapsibleRows.forEach((row) => {
        const kh = this.boundKeyHandlers[j++];
        if (kh) row.removeEventListener('keydown', kh);
      });
    }
  }

  changeBillingCycle() {
    //console.log(this.billingCycle);
    if(this.billingCycle == "month") this.billingCycle = "year";
    else this.billingCycle = "month";
  }

  private setupBillingToggle() {
    this.billingToggle = document.getElementById('billingToggle');
    this.monthlyLabel = document.querySelector('label[for="monthly"]');
    this.annualLabel = document.querySelector('label[for="annual"]');

    if (this.billingToggle && this.monthlyLabel && this.annualLabel) {
      const billingHandler = () => {
        this.billingToggle!.classList.toggle('active');
        this.monthlyLabel!.classList.toggle('active');
        this.annualLabel!.classList.toggle('active');
        document.body.classList.toggle('billing-annual');
      };
      this.billingToggle.addEventListener('click', billingHandler);
      this.boundToggleFns.push(billingHandler);
    }
  }

  private setupCollapsibleRows() {
    this.collapsibleRows = document.querySelectorAll('.collapsible-row');
    this.collapsibleRows.forEach((row) => {
      const group = row.getAttribute('data-group');
      if (!group) return;

      row.setAttribute('tabindex', '0');
      row.setAttribute('role', 'button');
      row.setAttribute('aria-expanded', 'false');

      const childRows = document.querySelectorAll(`tr[data-parent="${group}"]`);
      childRows.forEach((child) => (child as HTMLElement).style.display = 'none');

      const toggleGroup = () => {
        const isOpen = row.classList.toggle('is-open');
        row.setAttribute('aria-expanded', String(isOpen));
        childRows.forEach((child) => (child as HTMLElement).style.display = isOpen ? 'table-row' : 'none');
      };

      row.addEventListener('click', toggleGroup);
      this.boundToggleFns.push(toggleGroup);

      const keyHandler = (event: Event) => {
        if (event instanceof KeyboardEvent) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleGroup();
          }
        }
      };

      row.addEventListener('keydown', keyHandler);
      this.boundKeyHandlers.push(keyHandler);
    });
  }

 
  private async detectCountryCode(): Promise<string | null> {
    const geoCountry = await this.tryBrowserGeolocation();
    if (geoCountry) return geoCountry;

    const ipCountry = await this.tryIpGeolocation();
    if (ipCountry) return ipCountry;

    return null;
  }

  private tryBrowserGeolocation(timeoutMs = 7000): Promise<string | null> {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve(null);
        return;
      }
      const success = async (pos: GeolocationPosition) => {
        try {
          const lat = pos.coords.latitude;
          const lon = pos.coords.longitude;
          const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`;
          const resp = await fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } });
          if (!resp.ok) { resolve(null); return; }
          const data = await resp.json();
          const countryCode = (data.address && data.address.country_code) ? data.address.country_code.toUpperCase() : null;
          resolve(countryCode);
        } catch (e) {
          console.warn('reverse geocode failed', e);
          resolve(null);
        }
      };

      const error = (err: GeolocationPositionError) => {
        console.warn('geolocation error', err);
        resolve(null);
      };

      const options: PositionOptions = { timeout: timeoutMs, maximumAge: 60_000 };

      navigator.geolocation.getCurrentPosition(success, error, options);
    });
  }
//donot delete this function it is used in new code implementation for faq and pricing tables
  private async tryIpGeolocation(): Promise<string | null> {
    try {
      const resp = await fetch('https://ipapi.co/json/');
      if (!resp.ok) return null;
      const data = await resp.json();
      if (data && data.country_code) {
        return data.country_code.toUpperCase();
      }
      return null;
    } catch (e) {
      console.warn('ip geolocation failed', e);
      return null;
    }
  }

  private async detectCountryInfo(): Promise<{ code: string; name: string }> {
    const ipCountry = await this.tryIpGeolocationInfo();
    return {
      code: ipCountry?.code || 'IN',
      name: ipCountry?.name || ipCountry?.code || ''
    };
  }

  private async tryIpGeolocationInfo(): Promise<{ code: string | null; name: string | null } | null> {
    try {
      const resp = await fetch('https://ipapi.co/json/');
      if (!resp.ok) return null;
      const data = await resp.json();
      return {
        code: data?.country_code ? String(data.country_code).toUpperCase() : null,
        name: data?.country_name || null
      };
    } catch (e) {
      console.warn('ip geolocation failed', e);
      return null;
    }
  }

  private getSymbolForCountry(countryCode: string): string | null {
    if (!countryCode) return null;
    if (this.countryToCurrencySymbol[countryCode]) return this.countryToCurrencySymbol[countryCode];
    if (countryCode === 'US' || countryCode === 'CA' || countryCode === 'AU' || countryCode === 'SG') return '$';
    if (countryCode === 'JP') return '¥';
    if (countryCode === 'GB') return '£';
    if (countryCode === 'IN') return '₹';
    if (['DE', 'FR', 'ES', 'IT', 'NL', 'BE', 'AT', 'PT', 'IE', 'GR', 'FI', 'LU', 'SI', 'SK', 'EE', 'LV', 'LT', 'MT', 'CY'].includes(countryCode)) return '€';
    return null;
  }

  private replaceCurrencyInDom(symbol: string) {
    try {
      const els = document.querySelectorAll('.price-currency');
      if (els && els.length) {
        els.forEach(el => { el.textContent = symbol; });
      }
    } catch (e) {
      console.warn('replaceCurrencyInDom failed', e);
    }
  }


  openTerms(event?: Event) {
    if (event) { event.preventDefault(); }
    this.router.navigate(['/terms']);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  }
  openPrivacy(event?: Event) {
    if (event) { event.preventDefault(); }
    this.router.navigate(['/privacy-policy']);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  }
  openCookie(event?: Event) {
    if (event) { event.preventDefault(); }
    this.router.navigate(['/cookie']);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }


// new code implementation for faq and pricing tables

  activePlanId: string | number = 'team';
  user: number = 5;
  userOptions: number[] = [];
  planAmount: number | null = null;
  planAmountYearly: number | null = null;
  soloPlan: any = null;
  teamPlans: any[] = [];
  selectedTeamPlan: any = null;
  isLoadingPlans: boolean = true;
  freePlan: any = null;
  alyroBilling: 'month' | 'year' = 'year'; 
  enterprisePlan: any = {
    id: 'enterprise',
    title: 'ENTERPRISE',
    price: null,
    subtext: 'Precision & scale for big business',
    features: ['Everything in Team', 'CRM integration', 'API access', 'Custom workflows', 'Advanced permissions'],
    btnText: 'Contact Sales'
  };
  simplePlans: any[] = [
    {
      id: 'enterprise',
      title: 'ENTERPRISE',
      price: null,
      subtext: 'Precision & scale for big business',
      features: ['Everything in Team', 'CRM integration', 'API access', 'Custom workflows', 'Advanced permissions'],
      btnText: 'Contact Sales'
    }
  ];
  faqItems = [
    { 
      question: 'Can I upgrade anytime?', 
      answer: 'Yes, you can upgrade your plan at any time through your dashboard. Changes take effect immediately.',
      isOpen: false 
    },
    { 
      question: 'What happens after the free trial?', 
      answer: 'After your 14-day trial ends, you will be prompted to select a plan. No charges are made automatically.',
      isOpen: false 
    },
    { 
      question: 'What does price lock mean?', 
      answer: 'Price lock ensures that the monthly rate you sign up with stays the same for as long as you keep your subscription active.',
      isOpen: false 
    },
    { 
      question: 'How does pricing scale with stores?', 
      answer: 'Our pricing is per-location. As you add more stores, you simply add seats to your plan with a volume discount.',
      isOpen: false 
    },
    { 
      question: 'Is there a long-term contract?', 
      answer: 'No. Flexible plans with optional annual billing for maximum savings.',
      isOpen: true // Set the last one open by default like in your screenshot
    }
  ];

  standardPlans: any[] = [];
  subscriptionPlans: any[] = [];
  toggleItem(item: any) {
    item.isOpen = !item.isOpen;
  }
  selectUser(num: number) {
    this.user = num;
    this.checkForTeam();
  }
  setActive(title: string | number) {
    this.activePlanId = title;
  }

  onClickGetStarted(plan: any, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    const selectedPlan = plan?.title === 'TEAM' ? (this.selectedTeamPlan || plan) : plan;
    localStorage.setItem('pendingSubscriptionPlanId', String(selectedPlan?.id || plan?.id || ''));
    if (this.router.url.includes('/business-register')) {
      this.getStarted.emit();
      return;
    }
    this.router.navigate(['/business-register']);
  }

  checkForTeam() {
    if (!this.teamPlans.length) {
      this.selectedTeamPlan = null;
      this.planAmount = null;
      this.planAmountYearly = null;
      return;
    }

    this.selectedTeamPlan = this.teamPlans.find((x: any) => x.vcardCount === this.user) || this.teamPlans[0];

    const priceModel = this.detectedCountry === 'IN'
      ? this.selectedTeamPlan?.price?.india
      : this.selectedTeamPlan?.price?.default;

    this.planAmount = priceModel?.current ?? null;
    this.planAmountYearly = priceModel?.yearlyPrice ?? null;
  }

  getPriceModel(plan: any): any {
    return this.detectedCountry === 'IN' ? plan?.price?.india : plan?.price?.default;
  }

  formatPlanPrice(plan: any, key: 'current' | 'original' | 'yearlyPrice'): string {
    return this.formatAmount(this.getPriceModel(plan)?.[key], this.getPriceModel(plan));
  }

  formatTeamPrice(amount: number | null): string {
    return this.formatAmount(amount, this.getPriceModel(this.selectedTeamPlan));
  }

  private formatAmount(amount: any, priceModel: any): string {
    const value = Number(amount ?? 0);
    let symbol = priceModel?.currency || this.getCurrencySymbolFallback();
    if (symbol === '$' && priceModel?.currencyCode === 'CAD') symbol = 'C$';
    return `${symbol}${value.toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
  }

  private getCurrencySymbolFallback(): string {
    if (this.detectedCountry === 'IN') return '₹';
    if (this.detectedCountry === 'CA') return 'C$'; 
    return '$';
  }

  private getApiCurrencySymbol(plan: any): string | null {
    const value = plan?.currencySymbol || plan?.currency_symbol || plan?.currency || null;
    return this.normalizeCurrencySymbol(value);
  }

  private getApiCurrencyCode(plan: any, fallbackCode: string): string {
    const value = plan?.currencySymbol || fallbackCode;
    const normalized = String(value || fallbackCode).toUpperCase();
    if (normalized === '₹') return 'INR';
    if (normalized === 'C$') return 'CAD'; 
    if (normalized === '$') {
      return (this.detectedCountryName.trim().toLowerCase() === 'canada' || this.detectedCountry === 'CA') ? 'CAD' : 'USD';
    }
    return normalized;
  }

  private normalizeCurrencySymbol(currency: string | null): string | null {
    if (!currency) return null;
    const value = String(currency).toUpperCase();
    if (value === 'INR') return '₹';
    if (value === 'USD') return '$';
    if (value === 'CAD') return 'C$'; 
    return currency;
  }


  get hasAlyroPlans(): boolean {
    return this.simplePlans.some((p: any) => p?.title !== 'ENTERPRISE');
  }

  setAlyroBilling(cycle: 'month' | 'year') {
    this.alyroBilling = cycle;
  }

  private getAlyroSource(plan: any): any {
    return plan?.title === 'TEAM' ? (this.selectedTeamPlan || plan) : plan;
  }

  getAlyroPrice(plan: any): string {
    const source = this.getAlyroSource(plan);
    const model = this.getPriceModel(source);
    const monthly = Number(model?.current ?? 0);
    const yearly = Number(model?.yearlyPrice ?? 0);
    const amount = (!plan?.isFree && this.alyroBilling === 'year' && yearly > 0) ? Math.round(yearly / 12) : monthly;
    return this.formatAmount(amount, model);
  }

  getAlyroNote(plan: any): string {
    if (plan?.isFree) return 'Free forever';
    const source = this.getAlyroSource(plan);
    const model = this.getPriceModel(source);
    if (this.alyroBilling === 'year' && Number(model?.yearlyPrice ?? 0) > 0) {
      return `${this.formatAmount(model?.yearlyPrice, model)} charged yearly`;
    }
    return 'Billed monthly';
  }

  getAlyroSavePercent(plan: any): number {
    const model = this.getPriceModel(this.getAlyroSource(plan));
    const monthly = Number(model?.current ?? 0);
    const yearly = Number(model?.yearlyPrice ?? 0);
    if (monthly <= 0 || yearly <= 0) return 0;
    return Math.max(0, Math.round((1 - yearly / (monthly * 12)) * 100));
  }

  getAlyroBtnText(plan: any): string {
    if (plan?.isFree) return 'Get Started Free';
    if (plan?.title === 'TEAM') return 'Start Team Trial';
    return 'Choose ' + (plan?.name || plan?.title || '');
  }

  getSavingsMonths(plan: any): number {
    const model = this.getPriceModel(plan);
    const monthly = Number(model?.current ?? 0);
    const yearly = Number(model?.yearlyPrice ?? 0);
    if (monthly <= 0 || yearly <= 0) return 0;
    return Math.max(0, Math.round(12 - yearly / monthly));
  }

  getSubscriptionPlans(): Promise<void> {
    return new Promise((resolve) => {
      this.subscriptionService.list(this.detectedCountryName).subscribe((response: any) => {
        if (!response?.success || !Array.isArray(response?.data)) {
          resolve();
          return;
        }

        const approvedPlans = response.data.filter((x: any) => String(x?.status || '').toUpperCase() === 'APPROVED');
        const vcardPlans = approvedPlans.filter((x: any) => x?.type === 'vcard');
        const smartSitePlans = approvedPlans.filter((x: any) => x?.type === 'smart_site');

        const mappedVcardPlans = vcardPlans.map((plan: any) => ({
          id: plan.id,
          title: String(plan.name || '').toUpperCase(),
          name: plan.name,
          vcardCount: Number(plan.vcardCount || 0),
          isFree: Number(plan.price ?? 0) === 0, 
          price: {
            default: {
              original: null,
              current: plan.price ?? 0,
              yearlyPrice: plan.annualPrice ?? 0,
              currency: this.getApiCurrencySymbol(plan) || '$',
              currencyCode: this.getApiCurrencyCode(plan, 'USD')
            },
            india: {
              original: null,
              current: plan.price ?? 0,
              yearlyPrice: plan.annualPrice ?? 0,
              currency: this.getApiCurrencySymbol(plan) || '₹',
              currencyCode: this.getApiCurrencyCode(plan, 'INR')
            }
          },
          period: '/ month',
          savings: 'Save 2 months',
          subtext: plan.description || '',
          features: Array.isArray(plan.inclusions) ? plan.inclusions : [],
          btnText: 'Get Started'
        }));

        this.freePlan = mappedVcardPlans.find((x: any) => x.isFree && x.vcardCount <= 1) || null; 
        this.soloPlan = mappedVcardPlans.find((x: any) => x.vcardCount === 1 && !x.isFree) || null;
        this.teamPlans = mappedVcardPlans.filter((x: any) => x.vcardCount > 1);
        this.userOptions = [...new Set(this.teamPlans.map((x: any) => Number(x.vcardCount)).filter((x: number) => x > 1))]
          .sort((a: number, b: number) => a - b);

        if (this.userOptions.length) {
          this.user = this.userOptions.includes(this.user) ? this.user : this.userOptions[0];
        }

        const simplePlans: any[] = [];
        if (this.freePlan) simplePlans.push(this.freePlan); 
        if (this.soloPlan) simplePlans.push(this.soloPlan);
        if (this.teamPlans.length) {
          simplePlans.push({
            ...this.teamPlans[0],
            id: 'team',
            title: 'TEAM',
            subtext: this.teamPlans[0]?.subtext || 'Select QR pack'
          });
        }
        simplePlans.push(this.enterprisePlan);
        this.simplePlans = simplePlans;
        this.checkForTeam();

        const mappedSmartSitePlans = smartSitePlans.map((plan: any) => ({
          id: plan.id,
          title: plan.name,
          name: plan.name,
          description: plan.description || '',
          price: {
            default: {
              original: (Number(plan.price ?? 0) * 12),
              current: plan.price ?? 0,
              yearlyPrice: plan.annualPrice ?? 0,
              currency: this.getApiCurrencySymbol(plan) || '$',
              currencyCode: this.getApiCurrencyCode(plan, 'USD')
            },
            india: {
              original: (Number(plan.price ?? 0) * 12),
              current: plan.price ?? 0,
              yearlyPrice: plan.annualPrice ?? 0,
              currency: this.getApiCurrencySymbol(plan) || '₹',
              currencyCode: this.getApiCurrencyCode(plan, 'INR')
            }
          },
          features: Array.isArray(plan.inclusions) ? plan.inclusions : [],
          footerNote: plan.footerNote || ''
        }));

        this.standardPlans = mappedSmartSitePlans.filter((plan: any) => {
          const name = String(plan.name || '').toLowerCase();
          return name.includes('lite') || (name.includes('standard') && !name.includes('plus') && !name.includes('omni'));
        });

        this.subscriptionPlans = mappedSmartSitePlans.filter((plan: any) => {
          const name = String(plan.name || '').toLowerCase();
          return name.includes('plus') || name.includes('omni');
        });

        const remainingPlans = mappedSmartSitePlans.filter((plan: any) => {
          return !this.standardPlans.some((x: any) => x.id === plan.id)
            && !this.subscriptionPlans.some((x: any) => x.id === plan.id);
        });
        this.subscriptionPlans = [...this.subscriptionPlans, ...remainingPlans];

        resolve();
      }, () => resolve());
    });
  }
}